/** ----------------------------------------
     News Item
 ---------------------------------------- */

function newsItem(obj, theme, host) {
    let html = `
        <div class="news-card__space"></div> 
        <a class="grid__item--massive card news-card" href="${ obj.url }">
            <div class="card__thumb news-card__thumb">
                <img class="card__image news-card__image" src="${ obj.image }">
            </div>
            <div class="card__content news-card__content">
                <div class="card__date">${ obj.publish_at_human }</div>
                <div class="card__title news-card__title">${ obj.title }</div>
                <div class="card__desc news-card__desc">${ obj.excerpt }</div>
                ${ theme === 'rialto' ? `<span class="btn-inline--orange">${ host.translate('Verder lezen', 'Read more') }</span>` : '' }
                ${ theme === 'wca' ? `<span class="btn-inline--lila">${ host.translate('Verder lezen', 'Read more') }</span>` : '' }
            </div>
        </a>
            `;

    return html;
}

/** ----------------------------------------
    Export Templates
 ---------------------------------------- */

export {
    newsItem
}
